module.exports = __webpack_public_path__ + "static/assets/ec6a73c85e83c5db5a1db7134eca25ec.png";